import src from "IMAGE";
export default { src, width: 600, height: 191, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARUlEQVR42i3KsQpAYBhA0d+TGIzKg1CymBQWmTyAslgtvPHnKMO5000RsTGyMzPQUJEnWTh4uLk4WSm+IfvvnpqWiY7yBaaFT9t1eMwqAAAAAElFTkSuQmCC"};
